export default "__VITE_ASSET__CkyGuEgx__"